function getWindow() {
  return typeof window === 'undefined' ? null : window;
}

export function getFileNameFromUrl(url, fallback = 'sandrapay-transactions.csv') {
  try {
    const parsedUrl = new URL(url);
    const lastPathSegment = parsedUrl.pathname.split('/').filter(Boolean).pop();

    return lastPathSegment || fallback;
  } catch {
    return fallback;
  }
}

function openDownloadLink(url, webApp) {
  const win = getWindow();

  if (typeof webApp?.openLink === 'function') {
    webApp.openLink(url);
    return true;
  }

  if (win) {
    win.open(url, '_blank', 'noopener,noreferrer');
    return true;
  }

  return false;
}

export function requestTelegramFileDownload({ url, fileName, webApp } = {}) {
  const win = getWindow();
  const resolvedWebApp = webApp || win?.Telegram?.WebApp;
  const resolvedFileName = fileName || getFileNameFromUrl(url);

  if (!url) {
    return Promise.reject(new Error('Download link is missing'));
  }

  if (typeof resolvedWebApp?.downloadFile !== 'function') {
    openDownloadLink(url, resolvedWebApp);
    return Promise.resolve(false);
  }

  return new Promise((resolve, reject) => {
    try {
      resolvedWebApp.downloadFile(
        {
          url,
          file_name: resolvedFileName,
        },
        (isDownloading) => {
          if (isDownloading) {
            resolve(true);
            return;
          }

          reject(new Error('Download was cancelled'));
        }
      );
    } catch (error) {
      if (openDownloadLink(url, resolvedWebApp)) {
        resolve(false);
        return;
      }

      reject(error);
    }
  });
}
